// extracted by mini-css-extract-plugin
export default {"info":"_06Specimens_info__BnRaE"};